import React from 'react';
import { TextField } from '@mui/material';

function InputText({ sx = { marginTop: '5px' }, type, ...params }) {
  const inputProps =
    type === 'number'
      ? {
          ...params.inputProps,
          onWheel: (e) => e.target.blur(),
        }
      : params.inputProps;
  return (
    <TextField
      {...params}
      type={type || 'text'}
      sx={{
        ...sx,
        '&:hover': {
          '&& fieldset': {
            border: '1px solid currentcolor',
          },
        },
      }}
      inputProps={inputProps}
      fullWidth
      variant="outlined"
    />
  );
}

export default InputText;
